import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout/Layout';

import { useSelector } from 'react-redux'
import { RootState } from '../../store';
import { UserState } from '../../store/reducers/userReducer';

import styles from './index.module.css'

import { FileRepositoryService } from '../../services/fileRepository/fileRepository'
import LcLoading from '../../components/Generic/LcLoading';

import { FileField, SelectField } from '../../components/Form/Input';
import SideModal from '../../components/Layout/SideModal/SideModal';
import LcIconLink from '../../components/Generic/LcIconLink';
import { useSnackbar } from 'notistack';
import LcAccordion from '../../components/Generic/LcAccordion';
import HeyHoNewRequest, { FormDataHeyho } from '../../components/Generic/HeyHoNewRequest';
import LcNoData from '../../components/Generic/LcNoData';

export interface FileModel {
    children: FileModel[];
    clientAccessHeyHo: boolean;
    key: string;
    label: string;
    lastModified: string | null;
    size: number| null;
    storageClass: string | null;
    urlDownload?: string;
}

const FileRepository: React.FC = (props) => {

    const user = useSelector<RootState, UserState>(state => state.user);
    const service = new FileRepositoryService(props);
    const [notFoundMessage, setNotFoundMessage] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [records, setRecords] = useState<FileModel[]>([]);

    const [uploadModalVisible, setUploadModalVisible] = useState<boolean>(false);
    const [showFormFile, setShowFormFile] = useState<boolean>(false);
    const [file, setFile] = useState<any>();
    const { enqueueSnackbar } = useSnackbar();
    const [refresh, setRefresh] = useState<boolean>(false)

    const [accordionVisible, setAccordionVisible] = useState<boolean>(false)
    const [openModalNewRequest, setOpenModalNewRequest] = useState<boolean>(false)
    const [titleRequest, setTitleRequest] = useState('');
    const [descriptionRequest, setDescriptionRequest] = useState('');
    const [record, setRecord] = useState<FileModel>();
    const [formData, setFormData] = useState<FormDataHeyho>({
        title: '',
        description: '',
        gtmType: 0
    });

    useEffect(() => {
        if (user.ClientGroupSelected) {
            setIsLoading(true)
            setRecords([])
            setFile([])
            setNotFoundMessage('')

            service.GetListFileRepository().then(result => {
                if (result.status === 200) {
                    if (result.data.fileTree === null) {
                        setNotFoundMessage('Não foram encontrados arquivos.')
                        setIsLoading(false)
                        return;
                    }
                    else {
                        setIsLoading(false)
                        let data = result.data.fileTree.children
                        setRecords(data)
                    }
                }
            }).catch(e => {
                setNotFoundMessage('Não foram encontrados arquivos')
                setIsLoading(false)
            })
        }
    }, [user.ClientGroupSelected, user.refreshFlag, refresh]);

    function handleUpload() {
        setUploadModalVisible(!uploadModalVisible);
        setShowFormFile(!showFormFile)
    };

    const onChangeFileField = (fieldOpt: any) => {
        setFile(fieldOpt)
    }

    const resetData = () => {
        setUploadModalVisible(!uploadModalVisible);
        setShowFormFile(!showFormFile)
    };

    async function convertAttachment(anexo: any, toBinary: (file: Blob) => Promise<unknown>) {
        for (var i = 0; i < anexo.length; i++) {

            var fileBinary: any = {};
            var reponseBinary = await toBinary(anexo[i]);
            fileBinary.baseBinary = reponseBinary;
            fileBinary.fileName = anexo[i].name;
            fileBinary.contentType = anexo[i].type;
            if (anexo[i].anexosBinary == null) {
                anexo[i].anexosBinary = [];
            }
            anexo[i].anexosBinary = (fileBinary);
        }
    };

    const toBinary = (file: Blob) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });



    const sendFile = async (e: any) => {
        e.preventDefault()
        if (!file) return
        resetData()
        enqueueSnackbar(`O documento está sendo preparado para envio. Aguarde`, {
            variant: 'warning',
            preventDuplicate: true,
            persist: false,
        });
        setIsLoading(true);
        await convertAttachment(file, toBinary)

        const formFile = new FormData()

        formFile.append("formFile", file[0])

        await service.PostFileRepository(formFile, record)
        .then(response => {
            enqueueSnackbar(`O documento foi enviado com sucesso.`, {
                variant: 'success',
                preventDuplicate: true,
                persist: false,
            });
            setRefresh(!refresh);
        })
        .catch ((error) => {
            console.error(error) 
            enqueueSnackbar(`Ocorreu um erro ao enviar o arquivo`, {
                variant: 'error',
                preventDuplicate: true,
                persist: false,
            });
        }).finally(() => {
            setIsLoading(false);
            setFile([])
        })

    };

    const handleChange = (event: any) => {
        let _record = event.value;
        setRecord(_record);
    };

    const handleDownloadFile = async (file: FileModel) => {
        if(file.storageClass === "DEEP_ARCHIVE") {
            enqueueSnackbar(`Para baixar o arquivo ${file.label} é preciso abrir um chamado.`, {
                variant: 'info',
                preventDuplicate: true,
                persist: false,
            });
            setOpenModalNewRequest(true);
            setFormData({
                title:  `Solicitação de download de Arquivo: ${file.label}`,
                description: `Solicito o download do Arquivo: ${file.label}.\nlocalizado na pasta ${file.key} `,
                gtmType: 0
            })

        }else {
            window.open(file.urlDownload, '_blank')
        }
    }

    return (
        <Layout pageTitle="Repositório de arquivos" cardType functionsGeneric={[{
            icon: 'lci lci-download lci-rotate-180',
            tooltip: 'Upload de arquivos',
            onClick: () => handleUpload()
        }]} >
            <LcLoading label="Carregando arquivos" loading={isLoading}>
                {/* <LcIconLink icon="lci lci-download lci-rotate-180" tooltip={"Upload de arquivos"} tooltipPosition="left" onClick={() => handleUpload()} /> */}
                <SideModal header="Upload de arquivos" visible={uploadModalVisible}
                    onClose={() => { setUploadModalVisible(!uploadModalVisible); setShowFormFile(!showFormFile) }}>
                    {showFormFile &&
                        <form onSubmit={sendFile} method='post'>
                            <SelectField name="folderName" label="Selecione a pasta"
                                onChange={handleChange}
                                options={
                                    [{ name: 'HeyHo', value: "0" },
                                    { name: 'HeyHo/Atas', value: "1" },
                                    { name: 'HeyHo/Documentos', value: "2" },
                                    { name: 'SaaSUser', value: "3" },
                                    { name: 'Documentos', value: "4" },
                                    { name: 'Status Report', value: "5" },
                                    ]} required />

                            <span> O nome original do arquivo será mantido após o upload </span>
                            <FileField name="formFile" type="file" onChange={onChangeFileField} />

                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>
                                <button type="submit" id="d01fcc74-5bc1-4075-b8af-b89d782a83fb" className="lc-button bg-primary">
                                    Enviar
                                </button>
                            </div>
                        </form>
                    }
                </SideModal>
                {
                    records.length > 0 ?
                    <div className='scrollable-v'>
                        {
                            records.map((r: any, i: any) => {
                                if (r.children.length > 0) {
                                    return (
                                        <LcAccordion
                                            title={r.label}
                                            visible={accordionVisible}
                                            onChange={() => { setAccordionVisible(!accordionVisible) }}
                                            >

                                            {r.children.map((c: any, _i: any) => {

                                                if (c.children.length > 0) {

                                                    return (
                                                        <>
                                                            <LcAccordion
                                                                title={c.label}
                                                                visible={accordionVisible}
                                                                onChange={() => { setAccordionVisible(!accordionVisible) }}
                                                                >
                                                                <div className="scrollable-v" style={{ maxHeight: '60vh' }}>

                                                                    {c.children.map((_c: any, _in: any) => {

                                                                        let date = new Date(_c.lastModified);
                                                                        const day = date.getDate().toString().padStart(2, '0')
                                                                        const month = (date.getMonth() + 1).toString().padStart(2, '0')
                                                                        const year = date.getFullYear()
                                                                        const formattedDate = `${day}/${month}/${year}`

                                                                        return (
                                                                            <div className={styles.box}>

                                                                                <p><b>Nome do arquivo:</b> {_c.key}</p>
                                                                                <p><b>Data:</b> {formattedDate}</p>

                                                                                <p><b>Tamanho do arquivo:</b> {(_c.size / 1024).toFixed(0)} Kb</p>

                                                                                <button className="lc-button bg-primary" onClick={()=> handleDownloadFile(_c)}>
                                                                                Download
                                                                                    {/* <a href={_c.urlDownload} target="_blank">Download</a> */}
                                                                                </button>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </LcAccordion>
                                                            <hr></hr>
                                                        </>
                                                    )
                                                }
                                                else {
                                                    let date = new Date(c.lastModified);
                                                    const day = date.getDate().toString().padStart(2, '0')
                                                    const month = (date.getMonth() + 1).toString().padStart(2, '0')
                                                    const year = date.getFullYear()
                                                    const formattedDate = `${day}/${month}/${year}`

                                                    return (
                                                        <div className={styles.box}>
                                                            <p><b>Nome do arquivo:</b> {c.key}</p>
                                                            <p><b>Data:</b> {formattedDate}</p>
                                                            <p><b>Tamanho do arquivo:</b> {(c.size / 1024).toFixed(0)} Kb</p>
                                                            <button className="lc-button bg-primary" onClick={()=> handleDownloadFile(c)}> 
                                                                Download
                                                                {/* <a href={c.urlDownload} target="_blank">Download</a> */}

                                                            </button>
                                                        </div>
                                                    )
                                                }
                                            })}

                                        </LcAccordion>
                                    )
                                }
                                else {
                                    let date = new Date(r.lastModified);
                                    const day = date.getDate().toString().padStart(2, '0')
                                    const month = (date.getMonth() + 1).toString().padStart(2, '0')
                                    const year = date.getFullYear()
                                    const formattedDate = `${day}/${month}/${year}`

                                    return (
                                        <LcAccordion
                                        title={'Outros'}
                                        visible={accordionVisible}
                                        onChange={() => { setAccordionVisible(!accordionVisible) }}
                                        >
                                        <div className={styles.box}>
                                            <p><b>Nome do arquivo:</b> {r.key}</p>
                                            <p><b>Data:</b> {formattedDate}</p>

                                            <p><b>Tamanho do arquivo:</b> {(r.size / 1024).toFixed(0)} Kb</p>

                                            <button className="lc-button bg-primary" onClick={()=> handleDownloadFile(r)}>
                                            Download
                                                {/* <a href={r.urlDownload} target="_blank">Download</a> */}
                                            </button>
                                        </div>
                                        </LcAccordion>
                                    )
                                }
                            })
                        }
                    </div>
                    :
                    <LcNoData size='large' label={notFoundMessage} />
                }
            </LcLoading>
            <HeyHoNewRequest openModal={openModalNewRequest} formData={formData} onClose={setOpenModalNewRequest}/>
        </Layout >
    )
}

export default FileRepository;